import { render, staticRenderFns } from "./editStaffBreakHrs_component.vue?vue&type=template&id=540771be&scoped=true&"
import script from "../assets/js/editBreakComponent.js?vue&type=script&lang=js&"
export * from "../assets/js/editBreakComponent.js?vue&type=script&lang=js&"
import style0 from "./editStaffBreakHrs_component.vue?vue&type=style&index=0&id=540771be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540771be",
  null
  
)

export default component.exports